@if (type === 'Accept') {
  <div class="container authorize">
    <div class="icon">
      <div class="check-circle-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <path
            d="M12.04 20.44L21.91 10.57L19.95 8.61L12.04 16.52L8.05 12.53L6.09 14.49L12.04 20.44ZM14 28C12.0633 28 10.2433 27.6325 8.54 26.8975C6.83667 26.1625 5.355 25.165 4.095 23.905C2.835 22.645 1.8375 21.1633 1.1025 19.46C0.3675 17.7567 0 15.9367 0 14C0 12.0633 0.3675 10.2433 1.1025 8.54C1.8375 6.83667 2.835 5.355 4.095 4.095C5.355 2.835 6.83667 1.8375 8.54 1.1025C10.2433 0.3675 12.0633 0 14 0C15.9367 0 17.7567 0.3675 19.46 1.1025C21.1633 1.8375 22.645 2.835 23.905 4.095C25.165 5.355 26.1625 6.83667 26.8975 8.54C27.6325 10.2433 28 12.0633 28 14C28 15.9367 27.6325 17.7567 26.8975 19.46C26.1625 21.1633 25.165 22.645 23.905 23.905C22.645 25.165 21.1633 26.1625 19.46 26.8975C17.7567 27.6325 15.9367 28 14 28Z"
            fill="#4C69B1" />
          </svg>
        </div>
      </div>
      <div class="discription" mat-dialog-content i18n>Your authorization has been sent to the Dealership</div>
      <div class="buttons" mat-dialog-actions>
        <button color="primary" class="button-ok" mat-raised-button [mat-dialog-close]="true" i18n>OK</button>
      </div>
    </div>
  }

  @if (type === 'AcceptAll') {
    <div class="container authorize">
      <div class="icon">
        <div class="check-circle-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path
              d="M12.04 20.44L21.91 10.57L19.95 8.61L12.04 16.52L8.05 12.53L6.09 14.49L12.04 20.44ZM14 28C12.0633 28 10.2433 27.6325 8.54 26.8975C6.83667 26.1625 5.355 25.165 4.095 23.905C2.835 22.645 1.8375 21.1633 1.1025 19.46C0.3675 17.7567 0 15.9367 0 14C0 12.0633 0.3675 10.2433 1.1025 8.54C1.8375 6.83667 2.835 5.355 4.095 4.095C5.355 2.835 6.83667 1.8375 8.54 1.1025C10.2433 0.3675 12.0633 0 14 0C15.9367 0 17.7567 0.3675 19.46 1.1025C21.1633 1.8375 22.645 2.835 23.905 4.095C25.165 5.355 26.1625 6.83667 26.8975 8.54C27.6325 10.2433 28 12.0633 28 14C28 15.9367 27.6325 17.7567 26.8975 19.46C26.1625 21.1633 25.165 22.645 23.905 23.905C22.645 25.165 21.1633 26.1625 19.46 26.8975C17.7567 27.6325 15.9367 28 14 28Z"
              fill="#4C69B1" />
            </svg>
          </div>
        </div>
        <div class="discription" mat-dialog-content>
          @if (jobsCount === 'all') {
            <span i18n>You have authorized all jobs.</span>
          } @else {
            @if (+jobsCount !== 1) {
              <span>
                <ng-container i18n>You have authorized {{jobsCount}} jobs</ng-container>
              </span>
            } @else {
              <ng-container i18n>You have authorized {{ jobsCount }} job</ng-container>
            }
          }
          <span i18n>Your authorization has been sent to the Dealership</span>
        </div>
        <div class="buttons" mat-dialog-actions>
          <button color="primary" class="button-ok" mat-raised-button [mat-dialog-close]="true" i18n>OK</button>
        </div>
      </div>
    }

    @if (type === 'AcceptAllDisclaimer') {
      <div class="container authorize">
        <div class="icon">
          <div class="check-circle-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path
                d="M12.04 20.44L21.91 10.57L19.95 8.61L12.04 16.52L8.05 12.53L6.09 14.49L12.04 20.44ZM14 28C12.0633 28 10.2433 27.6325 8.54 26.8975C6.83667 26.1625 5.355 25.165 4.095 23.905C2.835 22.645 1.8375 21.1633 1.1025 19.46C0.3675 17.7567 0 15.9367 0 14C0 12.0633 0.3675 10.2433 1.1025 8.54C1.8375 6.83667 2.835 5.355 4.095 4.095C5.355 2.835 6.83667 1.8375 8.54 1.1025C10.2433 0.3675 12.0633 0 14 0C15.9367 0 17.7567 0.3675 19.46 1.1025C21.1633 1.8375 22.645 2.835 23.905 4.095C25.165 5.355 26.1625 6.83667 26.8975 8.54C27.6325 10.2433 28 12.0633 28 14C28 15.9367 27.6325 17.7567 26.8975 19.46C26.1625 21.1633 25.165 22.645 23.905 23.905C22.645 25.165 21.1633 26.1625 19.46 26.8975C17.7567 27.6325 15.9367 28 14 28Z"
                fill="#4C69B1" />
              </svg>
            </div>
          </div>
          <div class="discription" mat-dialog-content>
            @if (jobsCount === 'all') {
              <span i18n>Are you sure you want to authorize all jobs?</span>
            } @else {
              @if (+jobsCount !== 1) {
                <span>
                  <ng-container i18n>Are you sure you want to authorize {{ jobsCount }} jobs?</ng-container>
                </span>
              } @else {
                <ng-container i18n>Are you sure you want to authorize {{ jobsCount }} job?</ng-container>
              }
            }
          </div>
          <div class="buttons" mat-dialog-actions>
            <button mat-button class="button-cancel" [mat-dialog-close]="false" i18n>Cancel</button>
            <button color="primary" class="button-yes" [mat-dialog-close]="true" mat-raised-button i18n>Yes</button>
          </div>
        </div>
      }

      @if (type === 'Reject') {
        <div class="container decline">
          <div class="icon">
          </div>
          <div class="description" mat-dialog-content>
            <ng-container i18n>Are you sure you want to decline this job?</ng-container>
          </div>
          <div class="buttons" mat-dialog-actions>
            <button mat-button class="button-cancel" [mat-dialog-close]="false" i18n>Cancel</button>
            <button color="primary" class="button-yes" [mat-dialog-close]="true" mat-raised-button i18n>Yes</button>
          </div>
        </div>
      }


      @if (type === 'RejectAllDisclaimer') {
        <div class="container decline">
          <div class="icon">
          </div>
          <div class="description" mat-dialog-content>
            @if (jobsCount === 'all') {
              <span>
                <ng-container i18n>Are you sure you want to decline all jobs?</ng-container>
              </span>
            } @else {
              @if (+jobsCount !== 1) {
                <span>
                  <ng-container i18n>Are you sure you want to decline {{ jobsCount }} jobs?</ng-container>
                </span>
              } @else {
                <ng-container i18n>Are you sure you want to decline {{ jobsCount }} job?</ng-container>
              }
            }
          </div>
          <div class="buttons" mat-dialog-actions>
            <button mat-button class="button-cancel" [mat-dialog-close]="false" i18n>Cancel</button>
            <button color="primary" class="button-yes" [mat-dialog-close]="true" mat-raised-button i18n>Yes</button>
          </div>
        </div>
      }


      @if (type === 'LanguageDialog') {
        <div class="languageModel">
          <div class="chooseLang">
            <div mat-dialog-title class="titleLang">
              <img src="./../../assets/common/translate.svg" alt="">
            </div>
            <div>
              <p class="chooseText">Choose Language</p>
              <p class="chooseText languageContent">You can always change this later.</p>
            </div>
            <hr class="hr">
          </div>
          <div mat-dialog-content>
            <div class="contentLang">
              @for (i of languageConfiguration.Langauges; track i) {
                <div>
                  <div class="innerContent">
                    <img src="{{i.SvgFlagAddress}}" class="flag" alt="{{i.SvgFlagAddress}}">
                    <button mat-menu-item (click)="changeLanguage(i.LanguageFileName)" class="countryName">
                    {{i.LanguageToShowInMenu}}</button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (type === 'landingDialog') {
        <div class="container landingDialog">
          <div class="icon">
            <div class="personIcon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="person">
                  <mask id="mask0_946_136402" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                    width="32" height="32">
                    <rect id="Bounding box" width="32" height="32" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_946_136402)">
                    <path id="person_2"
                      d="M16 16.0002C14.5334 16.0002 13.2778 15.4779 12.2334 14.4335C11.1889 13.3891 10.6667 12.1335 10.6667 10.6668C10.6667 9.20016 11.1889 7.94461 12.2334 6.90016C13.2778 5.85572 14.5334 5.3335 16 5.3335C17.4667 5.3335 18.7223 5.85572 19.7667 6.90016C20.8112 7.94461 21.3334 9.20016 21.3334 10.6668C21.3334 12.1335 20.8112 13.3891 19.7667 14.4335C18.7223 15.4779 17.4667 16.0002 16 16.0002ZM5.33337 26.6668V22.9335C5.33337 22.1779 5.52782 21.4835 5.91671 20.8502C6.3056 20.2168 6.82226 19.7335 7.46671 19.4002C8.84449 18.7113 10.2445 18.1946 11.6667 17.8502C13.0889 17.5057 14.5334 17.3335 16 17.3335C17.4667 17.3335 18.9112 17.5057 20.3334 17.8502C21.7556 18.1946 23.1556 18.7113 24.5334 19.4002C25.1778 19.7335 25.6945 20.2168 26.0834 20.8502C26.4723 21.4835 26.6667 22.1779 26.6667 22.9335V26.6668H5.33337Z"
                      fill="#4C69B1" />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            @if (!content) {
              <mat-tab-group (swipeleft)="onSwipe('left')" (panleft)="onSwipe('left')" (swiperight)="onSwipe('right')" (panright)="onSwipe('right')" [selectedIndex]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="center" headerPosition="below">
                <mat-tab label=".">
                  <div class="discription" mat-dialog-content>
                    <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                    <div i18n>Your Service Advisor has identified new work to be done on your vehicle that needs your authorization</div>
                  </div>
                </mat-tab>
                <mat-tab label=".">
                  <div class="discription" mat-dialog-content>
                    <div i18n>Click Authorize or Decline to accept or reject the jobs</div>
                  </div>
                  <div class="buttons" mat-dialog-actions>
                    <button color="primary" class="button-ok" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
                  </div>
                </mat-tab>
              </mat-tab-group>
            }
            @if (content) {
              <mat-tab-group (swipeleft)="onSwipe('left')" (panleft)="onSwipe('left')" (swiperight)="onSwipe('right')" (panright)="onSwipe('right')" [selectedIndex]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="center" headerPosition="below">
                @for (contentData of content; track contentData; let i = $index) {
                  <mat-tab label=".">
                    <div class="discription" mat-dialog-content>
                      @if (i === 0) {
                        <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                      }
                      <div [innerHTML]="contentData">
                      </div>
                      @if (i == content.length-1) {
                        <div  class="buttons" mat-dialog-actions>
                          <button color="primary" class="button-ok" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
                        </div>
                      }
                    </div>
                  </mat-tab>
                }
              </mat-tab-group>
            }
          </div>
        }

        @if (type === 'orderCancelled') {
          <div class="container orderCancelled">
            <div class="icon">
              <div class="order-icons">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M11.1998 22.6667L15.9998 17.8667L20.7998 22.6667L22.6665 20.8001L17.8665 16.0001L22.6665 11.2001L20.7998 9.33341L15.9998 14.1334L11.1998 9.33341L9.33317 11.2001L14.1332 16.0001L9.33317 20.8001L11.1998 22.6667ZM15.9998 29.3334C14.1554 29.3334 12.4221 28.9834 10.7998 28.2834C9.17761 27.5834 7.7665 26.6334 6.5665 25.4334C5.3665 24.2334 4.4165 22.8223 3.7165 21.2001C3.0165 19.5779 2.6665 17.8445 2.6665 16.0001C2.6665 14.1556 3.0165 12.4223 3.7165 10.8001C4.4165 9.17786 5.3665 7.76675 6.5665 6.56675C7.7665 5.36675 9.17761 4.41675 10.7998 3.71675C12.4221 3.01675 14.1554 2.66675 15.9998 2.66675C17.8443 2.66675 19.5776 3.01675 21.1998 3.71675C22.8221 4.41675 24.2332 5.36675 25.4332 6.56675C26.6332 7.76675 27.5832 9.17786 28.2832 10.8001C28.9832 12.4223 29.3332 14.1556 29.3332 16.0001C29.3332 17.8445 28.9832 19.5779 28.2832 21.2001C27.5832 22.8223 26.6332 24.2334 25.4332 25.4334C24.2332 26.6334 22.8221 27.5834 21.1998 28.2834C19.5776 28.9834 17.8443 29.3334 15.9998 29.3334Z" fill="#4C69B1"/>
                </svg>
              </div>
            </div>
            <div class="discription" mat-dialog-content>
              <div class="discriptionHeader" i18n>Order Cancelled</div>
              <div class="discriptionContent" i18n>Your order has been cancelled</div>
            </div>
          </div>
        }

        @if (type === 'orderInvoiced') {
          <div class="container order-invoiced">
            <div class="icon">
              <div class="order-icons">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <path
                    d="M12.04 20.44L21.91 10.57L19.95 8.61L12.04 16.52L8.05 12.53L6.09 14.49L12.04 20.44ZM14 28C12.0633 28 10.2433 27.6325 8.54 26.8975C6.83667 26.1625 5.355 25.165 4.095 23.905C2.835 22.645 1.8375 21.1633 1.1025 19.46C0.3675 17.7567 0 15.9367 0 14C0 12.0633 0.3675 10.2433 1.1025 8.54C1.8375 6.83667 2.835 5.355 4.095 4.095C5.355 2.835 6.83667 1.8375 8.54 1.1025C10.2433 0.3675 12.0633 0 14 0C15.9367 0 17.7567 0.3675 19.46 1.1025C21.1633 1.8375 22.645 2.835 23.905 4.095C25.165 5.355 26.1625 6.83667 26.8975 8.54C27.6325 10.2433 28 12.0633 28 14C28 15.9367 27.6325 17.7567 26.8975 19.46C26.1625 21.1633 25.165 22.645 23.905 23.905C22.645 25.165 21.1633 26.1625 19.46 26.8975C17.7567 27.6325 15.9367 28 14 28Z"
                    fill="#4C69B1" />
                  </svg>
                </div>
              </div>
              <div class="discription" mat-dialog-content>
                <div class="discriptionHeader" i18n>Order Invoiced</div>
                <div class="discriptionContent" i18n>Your order has been invoiced and is being processed</div>
              </div>
            </div>
          }

          @if (type === 'sessionExpired') {
            <div class="container session-expired">
              <div class="icon">
                <div class="order-icons">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M20.3998 22.2667L22.2665 20.4001L17.3332 15.4667V9.33341H14.6665V16.5334L20.3998 22.2667ZM15.9998 29.3334C14.1554 29.3334 12.4221 28.9834 10.7998 28.2834C9.17761 27.5834 7.7665 26.6334 6.5665 25.4334C5.3665 24.2334 4.4165 22.8223 3.7165 21.2001C3.0165 19.5779 2.6665 17.8445 2.6665 16.0001C2.6665 14.1556 3.0165 12.4223 3.7165 10.8001C4.4165 9.17786 5.3665 7.76675 6.5665 6.56675C7.7665 5.36675 9.17761 4.41675 10.7998 3.71675C12.4221 3.01675 14.1554 2.66675 15.9998 2.66675C17.8443 2.66675 19.5776 3.01675 21.1998 3.71675C22.8221 4.41675 24.2332 5.36675 25.4332 6.56675C26.6332 7.76675 27.5832 9.17786 28.2832 10.8001C28.9832 12.4223 29.3332 14.1556 29.3332 16.0001C29.3332 17.8445 28.9832 19.5779 28.2832 21.2001C27.5832 22.8223 26.6332 24.2334 25.4332 25.4334C24.2332 26.6334 22.8221 27.5834 21.1998 28.2834C19.5776 28.9834 17.8443 29.3334 15.9998 29.3334Z" fill="#4C69B1"/>
                  </svg>
                </div>
              </div>
              <div class="discription" mat-dialog-content>
                <div class="discriptionHeader" i18n>Session Expired</div>
                <div class="discriptionContent" i18n>Please contact your Service Center/Advisor to request a new link.</div>
              </div>
            </div>
          }

          @if (type === 'VHCReportWelcomeDialog') {
            <div class="container vhc-report-welcome-dialog">
              <div class="icon">
                <div class="order-icons">
                  <img src="./../../assets/common/person.svg" alt="File not found." i18n-alt>
                </div>
              </div>
              <div class="discription" mat-dialog-content>
                <div class="discriptionHeader">
                  <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                  @if (!content) {
                    <div class="discriptionContent" i18n>We have carried out a health check of your vehicle. If you have any questions regarding the items listed, please contact us.</div>
                  }
                  @if (content) {
                    <div [innerHTML]='content' class="discriptionContent">
                    </div>
                  }
                </div>
                <div class="buttons vhc-report-welcome-dialog-buttons" mat-dialog-actions>
                  <button mat-button [mat-dialog-close]="false" class="button-skip" i18n>Skip</button>
                  <button color="primary" [mat-dialog-close]="true" mat-raised-button class="button-take-tour" i18n>Tour Guide</button>
                </div>
              </div>
            </div>
          }

          @if (type === 'VHCReportWelcomeDialogInLargeScreen') {
            <div class="container vhc-report-welcome-dialog">
              <div class="icon">
                <div class="order-icons">
                  <img src="./../../assets/common/person.svg" alt="File not found." i18n-alt>
                </div>
              </div>
              <div class="discription" mat-dialog-content>
                <div class="discriptionHeader">
                  <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                  @if (!content) {
                    <div class="discriptionContent" i18n>We have carried out a health check of your vehicle. If you have any questions regarding the items listed, please contact us.</div>
                  }
                  @if (content) {
                    <div [innerHTML]='content' class="discriptionContent">
                    </div>
                  }
                </div>
                <div  class="buttons" mat-dialog-actions>
                  <button color="primary" class="button-ok" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
                </div>
              </div>
            </div>
          }

          @if (type === 'ProformaInvoiceWelcomeDialog') {
            <div class="container vhc-report-welcome-dialog">
              <div class="icon">
                <div class="order-icons">
                  <img src="./../../assets/common/person.svg" alt="File not found." i18n-alt>
                </div>
              </div>
              <div class="discription" mat-dialog-content>
                <div class="discriptionHeader">
                  <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                  @if (!content) {
                    <div class="discriptionContent" i18n>Review the proforma invoice we sent. 
                      Click "Authorize" to accept. 
                      If you need a callback, our customer service team will reach out.</div>
                  }
                  @if (content) {
                    <div [innerHTML]='content' class="discriptionContent">
                    </div>
                  }
                </div>
                <div class="buttons vhc-report-welcome-dialog-buttons" mat-dialog-actions>
                  <button mat-button [mat-dialog-close]="false" class="button-skip" i18n>Skip</button>
                  <button color="primary" [mat-dialog-close]="true" mat-raised-button class="button-take-tour" i18n>Tour Guide</button>
                </div>
              </div>
            </div>
          }

          @if (type === 'ProformaInvoiceWelcomeDialogInLargeScreen') {
            <div class="container vhc-report-welcome-dialog">
              <div class="icon">
                <div class="order-icons">
                  <img src="./../../assets/common/person.svg" alt="File not found." i18n-alt>
                </div>
              </div>
              <div class="discription" mat-dialog-content>
                <div class="discriptionHeader">
                  <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                  @if (!content) {
                    <div class="discriptionContent" i18n>Review the proforma invoice we sent. 
                      Click "Authorize" to accept. 
                      If you need a callback, our customer service team will reach out.</div>
                  }
                  @if (content) {
                    <div [innerHTML]='content' class="discriptionContent">
                    </div>
                  }
                </div>
                <div class="buttons" mat-dialog-actions>
                  <button color="primary" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
                </div>
              </div>
            </div>
          }

          @if (type === 'costOfWorkInfo') {
            <div class="container cost-of-work">
              <div class="discription" mat-dialog-content>
                @if (!content) {
                  <div class="discriptionContent" i18n>Final prices include Parts, Labor and Tax. Payment in full will be due before the vehicle can be collected.</div>
                }
                @if (content) {
                  <div [innerHTML]='content' class="discriptionContent">
                  </div>
                }
              </div>
              <div class="buttons" mat-dialog-actions>
                <button color="primary" class="button-ok" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
              </div>
            </div>
          }

          <!-- proforma invoice-->
          @if (type === 'proformaInvoiceLandingDialog') {
            <div class="container proformaInvoiceLandingDialog">
              <div class="icon">
                <div class="order-icons">
                  <img src="./../../assets/common/person.svg" alt="File not found." i18n-alt>
                </div>
              </div>
              @if (!content) {
                <mat-tab-group  (swipeleft)="onSwipe('left')" (panleft)="onSwipe('left')" (swiperight)="onSwipe('right')"
                  (panright)="onSwipe('right')" [selectedIndex]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="center"
                  headerPosition="below">
                  <mat-tab label=".">
                    <div class="discription" mat-dialog-content>
                      <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                      <div i18n>A proforma invoice has been delivered for your review</div>
                    </div>
                  </mat-tab>
                  <mat-tab label=".">
                    <div class="discription" mat-dialog-content>
                      <div i18n>Click Authorize to accept.If you request a callback, our customer service specialists will reach out to assist you.</div>
                    </div>
                    <div class="buttons" mat-dialog-actions>
                      <button color="primary" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              }
              @if (content) {
                <mat-tab-group (swipeleft)="onSwipe('left')" (panleft)="onSwipe('left')" (swiperight)="onSwipe('right')" (panright)="onSwipe('right')" [selectedIndex]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="center" headerPosition="below">
                  @for (contentData of content; track contentData; let i = $index) {
                    <mat-tab label=".">
                      <div class="discription" mat-dialog-content>
                        @if (i === 0) {
                          <div class="welcome-text" i18n>Welcome, {{this.customerName}}!</div>
                        }
                        <div [innerHTML]="contentData">
                        </div>
                        @if (i == content.length-1) {
                          <div  class="buttons" mat-dialog-actions>
                            <button color="primary" class="button-ok" [mat-dialog-close]="true" mat-raised-button i18n>OK</button>
                          </div>
                        }
                      </div>
                    </mat-tab>
                  }
                </mat-tab-group>
              }
            </div>
          }

          @if (type === 'RequestCallback') {
            <div class="container callBack">
              <div class="icon">
                <div class="check-circle-icon">
                  <img src="./../../assets/common/check-circle.svg" alt="File not found." i18n-alt>
                </div>
              </div>
              <div class="discription" mat-dialog-content i18n>Our customer service professionals will reach out to you shortly</div>
              <div class="buttons" mat-dialog-actions>
                <button color="primary" mat-raised-button [mat-dialog-close]="true" i18n>OK</button>
              </div>
            </div>
          }

<!-- vhc-auth-jobs -->
  @if(context=='VHC'){
<div class="container-authorize">
    <div mat-dialog-content>
        <p class="heading" i18n>Decline {{serviceJob}}?</p>
    </div>
    <div class="main-description" mat-dialog-content>
        <p class="description" i18n>{{checkpoint}} {{finding}} is in {{condition}} condition. Your Service Advisor recommends this job.</p>
    </div>
    <div class="buttons" mat-dialog-actions>
        <button mat-button class="cancel-button" [mat-dialog-close]="false" i18n>Cancel</button>
        <button  mat-button class="yes-button" [mat-dialog-close]="true" i18n>Continue</button>
    </div>
</div>
}

<!-- vhc-auth-jobs -->
@if(context=='Quote'){
  <div class="container-authorize">
      <div mat-dialog-content>
          <p class="heading" i18n>Decline {{serviceJob}}?</p>
      </div>
      <div class="main-description" mat-dialog-content>
          <p class="description" i18n> Your Service Advisor recommends this job.</p>
      </div>
      <div class="buttons" mat-dialog-actions>
          <button mat-button class="cancel-button" [mat-dialog-close]="false" i18n>Cancel</button>
          <button  mat-button class="yes-button" [mat-dialog-close]="true" i18n>Continue</button>
      </div>
  </div>
  }

@if(type === 'AcceptDisclaimer'){
<div class="container-authorize-all">
    <div mat-dialog-content>
        <p class="heading" i18n>Authorize remaining jobs?</p>
    </div>
    <div class="main-description" mat-dialog-content>
        <p class="description" i18n>
            You are authorizing {{jobsCount}} remaining jobs. The total cost of work is 
            <span class="highlight-cost">${{cost}}</span>
          </p>
    </div>
    <div class="buttons" mat-dialog-actions>
        <button mat-button class="cancel-button" [mat-dialog-close]="false" i18n>Cancel</button>
        <button  mat-button class="yes-button" [mat-dialog-close]="true" i18n>Continue</button>
    </div>
</div>
}

@if(type === 'RejectDisclaimer'){
<div class="container-decline-all">
    <div mat-dialog-content>
      <img src="./../../assets/common/warning-icon.png" class="warning-image" alt="File not found." i18n-alt>
        <p class="heading" i18n>Decline All jobs?</p>
    </div>
    <div class="main-description" mat-dialog-content>
        <p class="description" i18n>Your Service Advisor recommends these jobs.</p>
    </div>
    <div class="buttons" mat-dialog-actions>
        <button mat-button class="cancel-button" [mat-dialog-close]="false" i18n>Cancel</button>
        <button  mat-button class="yes-button" [mat-dialog-close]="true" i18n>Continue</button>
    </div>
</div>
}

@if(type === 'NotProvidedDisclaimer'){
<div class="container-request-callback">
    <div mat-dialog-content>
        <p class="heading" i18n>Request Successfull</p>
    </div>
    <div class="main-description" mat-dialog-content>
        <p class="description" i18n>Our customer service specialists will contact you shortly</p>
    </div>
    <div class="request-callback-button" mat-dialog-actions>
        <button color="primary" class="yes-button" [mat-dialog-close]="true" i18n>Ok</button>
    </div>
</div>
}


@if(type === 'InvoiceAuthorized'){
  <div class="container-request-callback">
      <div mat-dialog-content>
          <p class="heading" i18n>Invoice Authorized</p>
      </div>
      <div class="main-description" mat-dialog-content>
          <p class="description" i18n>Your authorization has been sent to the dealership.</p>
      </div>
      <div class="buttons" mat-dialog-actions>
          <button color="primary" class="yes-button" [mat-dialog-close]="true" i18n>Ok</button>
      </div>
  </div>
  }

  @if(type === 'InvoicePdfDownload'){
    <div class="container-request-callback">
        <div mat-dialog-content>
            <p class="heading" i18n>Download successful</p>
        </div>
        <div class="main-description" mat-dialog-content>
            <p class="description" i18n>Invoice pdf downloaded successfully.</p>
        </div>
        <div class="buttons" mat-dialog-actions>
            <button color="primary" class="yes-button" [mat-dialog-close]="true" i18n>Ok</button>
        </div>
    </div>
    }  